import angular from 'angular'
import userActions from './user_actions_service'

export default angular.module('adminPanel.userActions', []).factory('userActions', userActions)
